export default "__VITE_ASSET__SaNBLkcY__"